if (!customElements.get('quick-add-modal')) {
  customElements.define(
    'quick-add-modal',
    class QuickAddModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickAddInfo-"]');
      }

      hide(preventFocus = false) {
        const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        if (cartNotification) cartNotification.setActiveElement(this.openedBy);
        this.modalContent.innerHTML = '';

        if (preventFocus) this.openedBy = null;
        super.hide();
      }

      show(opener) {
        opener.setAttribute('aria-disabled', true);
        opener.classList.add('loading');
        opener.querySelector('.loading__spinner').classList.remove('hidden');

        fetch(opener.getAttribute('data-product-url'))
          .then((response) => response.text())
          .then((responseText) => {
            const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
            this.productElement = responseHTML.querySelector('section[id^="MainProduct-"]');
            this.productElement.classList.forEach((classApplied) => {
              if (classApplied.startsWith('color-') || classApplied === 'gradient')
                this.modalContent.classList.add(classApplied);
            });
            this.preventDuplicatedIDs();
            this.removeDOMElements();
            this.setInnerHTML(this.modalContent, this.productElement.innerHTML);

            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }

            if (window.ProductModel) window.ProductModel.loadShopifyXR();

            this.removeGalleryListSemantic();
            this.updateImageSizes();
            this.preventVariantURLSwitching();
            this.initializeColorFiltering();
            super.show(opener);
          })
          .finally(() => {
            opener.removeAttribute('aria-disabled');
            opener.classList.remove('loading');
            opener.querySelector('.loading__spinner').classList.add('hidden');
          });
      }

      setInnerHTML(element, html) {
        element.innerHTML = html;

        // Reinjects the script tags to allow execution. By default, scripts are disabled when using element.innerHTML.
        element.querySelectorAll('script').forEach((oldScriptTag) => {
          const newScriptTag = document.createElement('script');
          Array.from(oldScriptTag.attributes).forEach((attribute) => {
            newScriptTag.setAttribute(attribute.name, attribute.value);
          });
          newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
          oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
        });
      }

      preventVariantURLSwitching() {
        const variantPicker = this.modalContent.querySelector('variant-selects');
        if (!variantPicker) return;

        variantPicker.setAttribute('data-update-url', 'false');
      }

      removeDOMElements() {
        const pickupAvailability = this.productElement.querySelector('pickup-availability');
        if (pickupAvailability) pickupAvailability.remove();

        const productModal = this.productElement.querySelector('product-modal');
        if (productModal) productModal.remove();

        const modalDialog = this.productElement.querySelectorAll('modal-dialog');
        if (modalDialog) modalDialog.forEach((modal) => modal.remove());
      }

      preventDuplicatedIDs() {
        const sectionId = this.productElement.dataset.section;
        this.productElement.innerHTML = this.productElement.innerHTML.replaceAll(sectionId, `quickadd-${sectionId}`);
        this.productElement.querySelectorAll('variant-selects, product-info').forEach((element) => {
          element.dataset.originalSection = sectionId;
        });
      }

      removeGalleryListSemantic() {
        const galleryList = this.modalContent.querySelector('[id^="Slider-Gallery"]');
        if (!galleryList) return;

        galleryList.setAttribute('role', 'presentation');
        galleryList.querySelectorAll('[id^="Slide-"]').forEach((li) => li.setAttribute('role', 'presentation'));
      }

      updateImageSizes() {
        const product = this.modalContent.querySelector('.product');
        const desktopColumns = product.classList.contains('product--columns');
        if (!desktopColumns) return;

        const mediaImages = product.querySelectorAll('.product__media img');
        if (!mediaImages.length) return;

        let mediaImageSizes =
          '(min-width: 1000px) 715px, (min-width: 750px) calc((100vw - 11.5rem) / 2), calc(100vw - 4rem)';

        if (product.classList.contains('product--medium')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '605px');
        } else if (product.classList.contains('product--small')) {
          mediaImageSizes = mediaImageSizes.replace('715px', '495px');
        }

        mediaImages.forEach((img) => img.setAttribute('sizes', mediaImageSizes));
      }

      initializeColorFiltering() {
        // Helper function to find color option name in modal
        const getColorOptionName = () => {
          const possibleNames = ['Color', 'color', 'COLOR', 'Colour', 'colour'];
          for (const name of possibleNames) {
            const input = this.modalContent.querySelector(`input[name="${name}"]`);
            if (input) {
              console.log("Quick view - Found color option with name:", name);
              return name;
            }
          }
          return null;
        };

        // Color filtering function for modal
        const filterMediaByColor = (selectedColor) => {
          console.log("Quick view - Filtering media for color:", selectedColor);
          
          // Update color swatch name display in modal
          const colorSwatchName = this.modalContent.querySelector("#color-swatch-name");
          if (colorSwatchName) {
            colorSwatchName.innerHTML = selectedColor;
          }
          
          // Filter main product images in modal
          const mainImageSlides = this.modalContent.querySelectorAll('[data-media-id][data-color]');
          console.log("Quick view - Found main image slides:", mainImageSlides.length);
          
          mainImageSlides.forEach(slide => {
            const slideColor = slide.getAttribute('data-color');
            const slideId = slide.getAttribute('id');
            
            if (slideColor === selectedColor) {
              slide.style.display = 'block';
              slide.classList.remove('hide-media');
              if (slide.tagName === 'LI') {
                slide.style.listStyle = 'none';
              }
              console.log("Quick view - Showing main slide:", slideId, "color:", slideColor);
            } else {
              slide.style.display = 'none';
              slide.classList.add('hide-media');
              console.log("Quick view - Hiding main slide:", slideId, "color:", slideColor);
            }
          });
          
          // Filter thumbnail images in modal - use multiple selectors
          const thumbnailSlides = this.modalContent.querySelectorAll(
            '[data-target][data-color], .thumbnail-list__item[data-color], .color_slide[data-color]'
          );
          console.log("Quick view - Found thumbnail slides:", thumbnailSlides.length);
          
          // Debug: log all found thumbnail slides
          thumbnailSlides.forEach((slide, index) => {
            console.log(`Quick view - Thumbnail ${index}:`, {
              id: slide.getAttribute('id'),
              color: slide.getAttribute('data-color'),
              target: slide.getAttribute('data-target'),
              classes: slide.className
            });
          });
          
          thumbnailSlides.forEach(slide => {
            const slideColor = slide.getAttribute('data-color');
            const slideId = slide.getAttribute('id');
            
            if (slideColor === selectedColor) {
              slide.style.display = 'block';
              slide.classList.remove('hide-media');
              slide.style.visibility = 'visible';
              if (slide.tagName === 'LI') {
                slide.style.listStyle = 'none';
              }
              console.log("Quick view - Showing thumbnail slide:", slideId, "color:", slideColor);
            } else {
              slide.style.display = 'none';
              slide.classList.add('hide-media');
              slide.style.visibility = 'hidden';
              console.log("Quick view - Hiding thumbnail slide:", slideId, "color:", slideColor);
            }
          });
          
          // Fallback: Also filter any slides with .color-slide or .color_slide classes
          const fallbackSlides = this.modalContent.querySelectorAll('.color-slide[data-color], .color_slide[data-color]');
          console.log("Quick view - Found fallback slides:", fallbackSlides.length);
          
          fallbackSlides.forEach((slide, index) => {
            const slideColor = slide.getAttribute('data-color');
            console.log(`Quick view - Fallback slide ${index}:`, {
              id: slide.getAttribute('id'),
              color: slideColor,
              classes: slide.className
            });
            
            if (slideColor === selectedColor) {
              slide.style.display = 'block';
              slide.classList.remove('hide-media');
              slide.style.visibility = 'visible';
            } else {
              slide.style.display = 'none';
              slide.classList.add('hide-media');
              slide.style.visibility = 'hidden';
            }
          });
          
          // Additional comprehensive search for any element with data-color
          const allColorSlides = this.modalContent.querySelectorAll('[data-color]');
          console.log("Quick view - All elements with data-color:", allColorSlides.length);
          
          allColorSlides.forEach((slide, index) => {
            const slideColor = slide.getAttribute('data-color');
            // Skip if it doesn't match any expected classes or attributes
            if (!slide.hasAttribute('data-media-id') && !slide.hasAttribute('data-target') && 
                !slide.classList.contains('color_slide') && !slide.classList.contains('color-slide')) {
              return;
            }
            
            if (slideColor === selectedColor) {
              slide.style.display = 'block';
              slide.classList.remove('hide-media');
              slide.style.visibility = 'visible';
            } else {
              slide.style.display = 'none';
              slide.classList.add('hide-media');
              slide.style.visibility = 'hidden';
            }
          });
          
          // Update media gallery navigation in modal
          const mediaGallery = this.modalContent.querySelector('media-gallery');
          if (mediaGallery) {
            // Reset current index to 0 for the new color set
            mediaGallery.currentIndex = 0;
            
            // Get visible slides for the selected color
            const visibleSlides = Array.from(mediaGallery.elements.viewer.querySelectorAll('[data-media-id]'))
              .filter(slide => 
                slide.style.display !== 'none' && 
                !slide.classList.contains('hide-media') && 
                !slide.classList.contains('product__media-zoom-hover')
              );
            
            console.log("Quick view - Visible slides after filtering:", visibleSlides.length);
            
            // Update the counter to show correct total
            const counterTotal = mediaGallery.querySelector('.slider-counter--total');
            if (counterTotal) {
              counterTotal.textContent = visibleSlides.length;
              console.log("Quick view - Updated counter total to:", visibleSlides.length);
            }
            
            // Set the first visible slide as active
            if (visibleSlides.length > 0) {
              const firstVisibleMediaId = visibleSlides[0].dataset.mediaId;
              console.log("Quick view - Setting first visible slide as active:", firstVisibleMediaId);
              mediaGallery.setActiveMedia(firstVisibleMediaId);
              
              // Update counter current to 1
              const counterCurrent = mediaGallery.querySelector('.slider-counter--current');
              if (counterCurrent) {
                counterCurrent.textContent = '1';
              }
            }
            
            // Force update of the gallery
            if (mediaGallery.updateCounter) {
              mediaGallery.updateCounter();
            }
          }
        };

        // Set up color change event listeners in modal
        const setupColorChangeListeners = () => {
          const colorOptionName = getColorOptionName();
          if (!colorOptionName) {
            console.log("Quick view - No color option found");
            return;
          }
          
          const colorRadios = this.modalContent.querySelectorAll(`input[name="${colorOptionName}"]`);
          console.log("Quick view - Found color radios:", colorRadios.length, "for option:", colorOptionName);
          
          colorRadios.forEach(radio => {
            radio.addEventListener('change', function() {
              if (this.checked) {
                const selectedColor = this.value;
                console.log("Quick view - Color changed to:", selectedColor);
                filterMediaByColor(selectedColor);
              }
            });
          });
        };

        // Initialize color filtering
        setTimeout(() => {
          console.log("Quick view - Initializing color filtering...");
          setupColorChangeListeners();
          
          // Handle initial color selection
          const colorOptionName = getColorOptionName();
          if (colorOptionName) {
            const checkedColorRadio = this.modalContent.querySelector(`input[name="${colorOptionName}"]:checked`);
            if (checkedColorRadio) {
              const selectedColor = checkedColorRadio.value;
              console.log("Quick view - Initial color detected:", selectedColor, "for option:", colorOptionName);
              filterMediaByColor(selectedColor);
            } else {
              console.log("Quick view - No checked color radio found");
            }
          } else {
            console.log("Quick view - No color option name found");
          }
        }, 300); // Increased delay to ensure modal content is fully loaded
      }
    }
  );
}
